import React, {useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import {
  TableCell,
  TableRow
} from '@material-ui/core';
import { RequestAccessStatus } from 'helpers/orders';


const defaultCustomerGroups = [
  {
    code: 'Not Logged In',
    id: 0
  },
  {
    code: 'General',
    id: 1
  }
];


const MassEditRequestAccessRow = (props) => {
  const {
    group_id,
    id,
    email,
    firstname,
    lastname,
    request_access
  } = props.checkedRowData;
  const { dynamicAccessStatus } = props;
  const { customerGroups } = useSelector((state) => state.customers);
  const [statusAndManageAccessData, setStatusAndManageAccessData] = useState(request_access);
  const code = [...defaultCustomerGroups, ...customerGroups].find((groupItem) => groupItem.id == group_id)?.code || '';

  useEffect(() => {
    if (dynamicAccessStatus) {
      setStatusAndManageAccessData(dynamicAccessStatus);
    }
  }, [dynamicAccessStatus]);


  return (
    <TableRow>
      <TableCell>
        {id}
      </TableCell>
      <TableCell>
        {email}
      </TableCell>
      <TableCell>
        {firstname}
      </TableCell>
      <TableCell>
        {lastname}
      </TableCell>
      <TableCell>
        {code}
      </TableCell>
      <TableCell>
        {RequestAccessStatus[statusAndManageAccessData] || ''}
      </TableCell>
    </TableRow>
  );
};

export default MassEditRequestAccessRow;
